  <div class="modal-header">
    <h4 class="modal-title">{{title}}</h4>
  </div>
  <div class="modal-body">
    <ng-content></ng-content>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn" [attr.aria-label]="confirmationConfig.cancelText"
            [ngClass]="'btn-outline-'+confirmationConfig.cancelColor"
            [attr.ngbAutofocus]="cancelNgbAutofocus"
            (click)="modal.close(false)">
      {{confirmationConfig.cancelText}}
    </button>
    <button type="button" class="btn" [attr.aria-label]="confirmationConfig.confirmText"
            [ngClass]="'btn-'+confirmationConfig.confirmColor"
            [attr.ngbAutofocus]="confirmNgbAutofocus"
      (click)="modal.close(true)">
      {{confirmationConfig.confirmText}}
    </button>
  </div>

